import * as Yup from 'yup';

const validationSchema = (isVirtual) => {
  return Yup.object({
    name: Yup.string().when('saleMethod', {
      is: (value) => (value && value === 'cod') || !isVirtual,
      then: (schema) => schema.required('validation/required'),
    }),
    address: Yup.string().when('saleMethod', {
      is: (value) => (value && value === 'cod') || !isVirtual,
      then: (schema) => schema.required('validation/required'),
    }),
    postalCode: Yup.string().when('saleMethod', {
      is: (value) => (value && value === 'cod') || !isVirtual,
      then: (schema) => schema.required('validation/required'),
    }),
    city: Yup.string().when('saleMethod', {
      is: (value) => (value && value === 'cod') || !isVirtual,
      then: (schema) => schema.required('validation/required'),
    }),
    phone: Yup.string().when('saleMethod', {
      is: (value) => (value && value === 'cod') || !isVirtual,
      then: (schema) => schema.required('validation/required'),
    }),
    countryCode: Yup.string().when('saleMethod', {
      is: (value) => (value && value === 'cod') || !isVirtual,
      then: (schema) => schema.required('validation/required'),
    }),
  });
};

export default validationSchema;
